import validateForm from '../validate_form'

validateForm({required: {message: '#message'}})